import {
  type AtRiskProFilters,
  atRiskProsFilterOptionsQueryOptions,
  atRiskProsListQueryOptions,
  atRiskProsSummaryQueryOptions,
} from "api/queries/atRiskPros";
import type { atRiskPros } from "routing/tree/admin";
import type { WarmableQuery } from "routing/warmQueries";

type AtRiskProsSearch = ReturnType<typeof atRiskPros.useSearch>;
type QueriesInput = { search: AtRiskProsSearch };

export const toFilters = (search: AtRiskProsSearch): AtRiskProFilters => ({
  ...search,
  market_id: search.market_id.length > 0 ? search.market_id : undefined,
});

export const atRiskProsListQuery = ({ search }: QueriesInput) => atRiskProsListQueryOptions(toFilters(search));

export const summaryQuery = ({ search }: QueriesInput) => atRiskProsSummaryQueryOptions(toFilters(search));

export const filterOptionsQuery = ({ search }: QueriesInput) => atRiskProsFilterOptionsQueryOptions(search.at_risk);

export const queries = (input: QueriesInput): Array<WarmableQuery> => [
  atRiskProsListQuery(input),
  summaryQuery(input),
  filterOptionsQuery(input),
];
